import { Component } from '@angular/core';
import { ClientSelectorComponent } from '../../client-selector/client-selector.component';
import { SetupWizard } from '../../../../../services/setup-wizard';
import { NavigationService } from '../../../../../services/navigation.service';
import { ALL_SETUP_WIZARD_STEPS, Client, SetupWizardState } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-setup-wizard-client-selector',
	imports: [ClientSelectorComponent],
	standalone: true,
	templateUrl: './setup-wizard-client-selector.html',
	styleUrl: './setup-wizard-client-selector.scss',
})
export class SetupWizardClientSelector {
	constructor(
		private nav: NavigationService,
		private setupWizard: SetupWizard
	) {}

	async ngOnInit() {
		//Always clear the previous client payload on client selector init
		await this.setupWizard.loadClientPayload$(ALL_SETUP_WIZARD_STEPS, undefined);
	}

	async onSelectClient(client: Client) {
		this.nav.navigate(['my', 'admin', 'setup-wizard', SetupWizardState.DASHBOARD, client.uuid]);
	}
}
